export default {
  types: {
    informative: 'Evénement Informatif',
    benefit: 'Evénement Prestation',
  }
}